import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";

export default function DimensionRadar({ dimensions, labels, lang = "ja" }) {
  const data = Object.entries(dimensions || {}).map(([k, v]) => ({
    dimension: (labels?.[k] && (labels[k][lang] || labels[k].en)) || k,
    value: v,
  }));

  return (
    <div className="w-full h-[320px]" data-testid="dimension-radar-chart">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="75%">
          <PolarGrid stroke="#1E2A3F" />
          <PolarAngleAxis
            dataKey="dimension"
            tick={{ fill: "#94A3B8", fontSize: 11, fontFamily: "IBM Plex Mono, monospace", letterSpacing: 1 }}
          />
          <PolarRadiusAxis
            domain={[0, 100]}
            tick={{ fill: "#64748B", fontSize: 9, fontFamily: "IBM Plex Mono, monospace" }}
            axisLine={false}
          />
          <Radar
            name="Score"
            dataKey="value"
            stroke="#3B82F6"
            fill="#3B82F6"
            fillOpacity={0.12}
            isAnimationActive={true}
            dot={{ r: 3, fill: "#3B82F6", stroke: "#0A0E1A", strokeWidth: 1.5 }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
